import styled from "styled-components"
import { globalMixins } from "../../../assets/styles/styled-components"

const getProgramColor = (props) => {
  switch (props.programCategory) {
    case "undergraduate":
      return (props) => props.theme.colors.undergraduate
    case "masters":
      return (props) => props.theme.colors.masters
    case "mba":
      return (props) => props.theme.colors.mba
    case "doctorate":
      return (props) => props.theme.colors.doctorate
    case "executive":
      return (props) => props.theme.colors.executive
    default:
      return (props) => props.theme.colors.darkGrey
  }
}

export const StyledProgramDetail = styled.div`
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 8px 16px ${(props) => props.theme.colors.darkGrey10};
  display: flex;
  flex-direction: column;
  position: relative;
  transition: 0.2s;
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 16px 16px ${(props) => props.theme.colors.darkGrey15};
    }
  }
`
export const StyledProgramHeader = styled.header`
  background-color: ${getProgramColor};
  background-image: url(${(props) =>
    props.programHeaderImage ? props.programHeaderImage : ""});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 16px 24px;

  & > p {
    ${globalMixins.typography.body}
    color: ${(props) => props.theme.colors.white};
  }
`
export const StyledProgramContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 24px;
`
export const StyledProgramTitle = styled.a`
  & p {
    ${globalMixins.typography.heading}
  }
`
export const StyledProgramDesc = styled.div`
  margin-top: 16px;
  & > p {
    ${globalMixins.typography.body}
  }
`
export const StyledProgramAttrList = styled.div`
  margin-top: 24px;
`
export const StyledProgramButton = styled.div`
  margin-top: 24px;

  & > .button-v2 {
    position: initial;

    &:before {
      position: absolute;
      content: "";
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }
  & > .button-v2--text {
    padding: 0;
    min-height: 0;
  }
`
